export default __webpack_public_path__ + "static/media/error.593a12ae.svg";